var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.8269 10.6667C3.90023 10.34 3.7669 9.87334 3.53357 9.64001L1.91356 8.02001C1.4069 7.51334 1.2069 6.97334 1.35356 6.50668C1.5069 6.04001 1.98023 5.72001 2.6869 5.60001L4.7669 5.25334C5.0669 5.20001 5.43356 4.93334 5.57356 4.66001L6.72023 2.36001C7.05357 1.70001 7.5069 1.33334 8.00023 1.33334C8.49357 1.33334 8.9469 1.70001 9.28023 2.36001L10.4269 4.66001C10.5136 4.83334 10.6936 5.00001 10.8869 5.11334L3.7069 12.2933C3.61356 12.3867 3.45356 12.3 3.48023 12.1667L3.8269 10.6667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4672 9.64001C12.2272 9.88001 12.0939 10.34 12.1739 10.6667L12.6339 12.6733C12.8272 13.5067 12.7072 14.1333 12.2939 14.4333C12.1272 14.5533 11.9272 14.6133 11.6939 14.6133C11.3539 14.6133 10.9539 14.4867 10.5139 14.2267L8.56052 13.0667C8.25385 12.8867 7.74719 12.8867 7.44052 13.0667L5.48719 14.2267C4.74719 14.66 4.11385 14.7333 3.70719 14.4333C3.55385 14.32 3.44052 14.1667 3.36719 13.9667L11.4739 5.86001C11.7805 5.55335 12.2139 5.41335 12.6339 5.48668L13.3072 5.60001C14.0139 5.72001 14.4872 6.04001 14.6405 6.50668C14.7872 6.97335 14.5872 7.51335 14.0805 8.02001L12.4672 9.64001Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.303a2be66549cafacb5194caf34ff05f.svg";
export { ForwardRef as ReactComponent };